import { useEventsContext } from '../../../context/events/EventsContext';
import { useRestoreClipsMutation } from '../operation.generated';
import { EventName } from '../../../services/EventTrackingService';
import { toast } from '../../Toaster';

const useRestoreClips = (
  options: Parameters<typeof useRestoreClipsMutation>[0] = {}
) => {
  const [eventTracking] = useEventsContext();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return useRestoreClipsMutation({
    ...options,
    onCompleted: data => {
      if (data.restoreClips.success) {
        const { numClipsRestored } = data.restoreClips;
        eventTracking.track({
          type: EventName.BatchClipsRestore,
          data: { total: numClipsRestored ?? 0 },
        });

        if (numClipsRestored) {
          toast({
            message: `Restored ${numClipsRestored} clip${
              numClipsRestored > 1 ? 's' : ''
            }.`,
            type: 'success',
          });
        }
      }
    },
  });
};

export default useRestoreClips;
